//import { Helmet } from "react-helmet-async";
import { Helmet } from 'react-helmet';
import Message from '../../component/Message';
//import Media from '../components/SocialMedia';

const Contact = () => {
  return (
    <div className="mt-40 mb-20 flex flex-col justify-center items-center max-w-screen-xl mx-auto">
      <Helmet>
        <title> Contact us</title>
        <meta name="description" content="contact ISO organization" />
      </Helmet>
      <div className="flex flex-col items-center ">
        <h1 className="text-2xl font-custom1 text-main mt-8">
          برای برقراری ارتباط، میتوانید از طریق اکانت تلگرام زیر به ما پیام
          بدهید
        </h1>

        {/* <Media /> */}
      </div>
      <div className="flex flex-col items-center mt-10">
        <button className="btn btn-primary">
          <a
            href="https://t.me/fitlinezsupport"
            target="_blank"
            rel="noopener noreferrer">
            <i className="fa fa-telegram"></i> Telegram
          </a>
        </button>
      </div>
    </div>
  );
};

export default Contact;
